/* ═══════════════════════════════════════════════════════════════════════════
   FILE: assets/2025-sticky-warenkorb-v2.js
   Isofin® Sticky Footer V2 – Pill + Bottom Sheet + Side Panel

   Mobile:  Full-width bar → Bottom Sheet Menü → delegate to sec-03 global fns
   Desktop: Floating Pill → Side Panel (von rechts) → delegate to sec-03 global fns

   Panel-Öffnung via window.openGuideModal / openGarantieModal / openWerkzeugModal
   (registriert durch 26-isowiz-step-4-sec-03.js)

   Scope: globally injected via theme.liquid (außer /cart, /checkout)
═══════════════════════════════════════════════════════════════════════════ */

(() => {
  'use strict';

  if (window.__MC_STICKY_V2_LOADED__) return;
  window.__MC_STICKY_V2_LOADED__ = true;

  // V27.7.14: Auf /pages/kalkulator nicht laden — der Wizard hat dort seine eigenen CTAs
  // (Inline-Button + interner Sticky-Footer). Sonst koennten Sticky-Cart und Result-Page
  // unterschiedliche Flaschenzahlen anzeigen (Cart-State vs. Calculated-State).
  try {
    var _p = (window.location.pathname || '').toLowerCase();
    if (_p.indexOf('/pages/kalkulator') === 0 || _p === '/pages/kalkulator/') {
      return;
    }
  } catch (_eEx) {}

  /* ═══════════════════════════════════════════════════════════════════════
     CONFIG
  ═══════════════════════════════════════════════════════════════════════ */
  var CFG = {
    CHECKOUT_URL: 'https://isofin.de/checkout',
    CALCULATOR_URL: 'https://isofin.de/pages/kalkulator',
    HERO_ANCHOR_URL: '/#hero',
    ISOFIN_VARIANT_ID: 55049427616117,
    FREE_SHIPPING_CENTS: 9999,
    POLL_INTERVAL_MS: 2500,
    BURST_MS: 10000,
    BURST_TICK_MS: 600,
    MOBILE_MAX_WIDTH: 640,
    MOBILE_EMPTY_THRESHOLD: 500,
    DESKTOP_EMPTY_THRESHOLD: 400,
    PANEL_RETRY_MAX: 8,
    PANEL_RETRY_MS: 500,
    PANEL_BOOT_FILES: {
      sec03: '26-isowiz-step-4-sec-03.js',
      anleitung: '26-isowiz-panel-anleitung.js',
      material: '26-isowiz-panel-material.js',
      wirkung: '26-isowiz-panel-wirkung.js'
    },
    HERO_SCROLL_FLAG_KEY: '__ISOWIZ_SW2_SCROLL_TO_HERO__'
  };
  var STICKY_PANEL_ANALYSIS_KEY = '__ISOWIZ_STICKY_PANEL_ANALYSIS__';

  var STATE = {
    lastToken: '',
    burstUntil: 0,
    panelEligible: false,
    lastBottleQty: 0,
    uiFilled: false,
    showSticky: false
  };

  var SCRIPT_PROMISES = {};
  var PREACT_COMPAT_PROMISE = null;

  /* ═══════════════════════════════════════════════════════════════════════
     PANEL CONFIG  (labels/icons for menu only — opening delegated to sec-03)
  ═══════════════════════════════════════════════════════════════════════ */
  var PANELS = {
    anleitung: {
      label: '3-Schritte Anleitung inkl. Bohrplan',
      icon: '📋',
      thumb: 'https://cdn.shopify.com/s/files/1/0846/5550/5691/files/isofin-starter-guide-500px.jpg?v=1761551030',
      sub: 'Individuell für Ihre Wand berechnet',
      globalFn: 'openGuideModal'
    },
    material: {
      label: 'Material',
      icon: '🧰',
      thumb: null,
      sub: 'Was Sie ben\u00f6tigen \u2013 meist bereits vorhanden',
      globalFn: 'openWerkzeugModal'
    },
    wirkung: {
      label: 'Wirkung',
      icon: '🛡️',
      thumb: 'https://cdn.shopify.com/s/files/1/0846/5550/5691/files/gempages_549688892727493681-ed944d56-1955-4f21-afc0-3833bb9b7397.gif?v=1752759375',
      sub: 'Labornachweis & lebenslange Garantie',
      globalFn: 'openGarantieModal'
    }
  };

  /* ═══════════════════════════════════════════════════════════════════════
     HELPERS
  ═══════════════════════════════════════════════════════════════════════ */
  function isMobile() {
    return (window.innerWidth || 0) < CFG.DESKTOP_BP;
  }

  function fmt(cents) {
    return ((cents || 0) / 100)
      .toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '€';
  }

  function tokenize(cart) {
    try {
      var parts = (cart.items || []).map(function (i) { return i.id + ':' + i.quantity; }).join('|');
      return parts + '::' + (cart.item_count || 0) + '::' + (cart.total_price || 0);
    } catch (e) { return String(Date.now()); }
  }

  function bottleCount(cart) {
    var vid = CFG.ISOFIN_VARIANT_ID;
    return (cart.items || []).reduce(function (s, it) {
      var v = typeof it.variant_id === 'string' ? Number(it.variant_id) : it.variant_id;
      return v === vid ? s + (it.quantity || 0) : s;
    }, 0);
  }

  async function fetchCart() {
    try {
      var r = await fetch('/cart.js?_sw=' + Date.now(), {
        credentials: 'same-origin', cache: 'no-store',
        headers: { 'Cache-Control': 'no-store, no-cache', 'Pragma': 'no-cache' }
      });
      return r.ok ? await r.json() : null;
    } catch (e) { return null; }
  }

  function readStorageAll(key) {
    var values = [];
    try {
      var sessionVal = sessionStorage.getItem(key);
      if (sessionVal != null) values.push(sessionVal);
    } catch (_) {}
    try {
      var localVal = localStorage.getItem(key);
      if (localVal != null) values.push(localVal);
    } catch (_) {}
    return values;
  }

  function readStorage(key) {
    var values = readStorageAll(key);
    return values.length ? values[0] : null;
  }

  function parseJSON(raw) {
    if (!raw || typeof raw !== 'string') return null;
    try {
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (_) {
      return null;
    }
  }

  function readStorageJSONCandidates(key) {
    var raws = readStorageAll(key);
    var out = [];
    for (var i = 0; i < raws.length; i++) {
      var parsed = parseJSON(raws[i]);
      if (parsed) out.push(parsed);
    }
    return out;
  }

  function readStorageJSONKey(key) {
    var candidates = readStorageJSONCandidates(key);
    return candidates.length ? candidates[0] : null;
  }

  function readNamespacedJSONCandidates(name) {
    var out = [];
    var keys = ['__ISOWIZ__::' + name, '__ISOWIZ_TEST__::' + name];
    for (var i = 0; i < keys.length; i++) {
      var parsedCandidates = readStorageJSONCandidates(keys[i]);
      for (var j = 0; j < parsedCandidates.length; j++) {
        out.push(parsedCandidates[j]);
      }
    }
    return out;
  }

  function readStorageModuleJSON(name) {
    try {
      var mod = window.IsoWiz && window.IsoWiz.Storage;
      if (mod && typeof mod.getJSON === 'function') {
        var data = mod.getJSON(name, null);
        if (data && typeof data === 'object') return data;
      }
    } catch (_) {}
    return null;
  }

  function hasCompleteAnalysis(a) {
    if (!a || typeof a !== 'object') return false;
    var bottles = Number(a.calculatedBottles || a.bottles || a.bottleCount || 0);
    var holes = Number(a.holeCount || 0);
    var spacing = Number(a.drillSpacingCm || a.spacing || 0);
    var depth = Number(a.drillDepthCm || a.drillDepth || 0);
    var wallThickness = Number(a.wallThicknessCm || a.wallThickness || 0);
    var moisture = String(a.moistureType || '').trim();
    var masonry = String(a.masonryType || '').trim();
    return (
      Number.isFinite(bottles) && bottles > 0 &&
      Number.isFinite(holes) && holes > 0 &&
      Number.isFinite(spacing) && spacing > 0 &&
      Number.isFinite(depth) && depth > 0 &&
      Number.isFinite(wallThickness) && wallThickness > 0 &&
      moisture.length > 0 &&
      masonry.length > 0
    );
  }

  function scoreAnalysisCandidate(a) {
    if (!a || typeof a !== 'object') return -1;
    var score = 0;
    if (Number(a.calculatedBottles || a.bottles || a.bottleCount || 0) > 0) score += 10;
    if (Number(a.holeCount || 0) > 0) score += 8;
    if (Number(a.drillDepthCm || a.drillDepth || 0) > 0) score += 6;
    if (Number(a.drillSpacingCm || a.spacing || 0) > 0) score += 4;
    if (Number(a.wallThicknessCm || a.wallThickness || 0) > 0) score += 4;
    if (Number(a.cornerCount || 0) >= 0) score += 2;
    if (String(a.masonryType || '').trim()) score += 2;
    if (String(a.moistureType || '').trim()) score += 2;
    if (Number(a.totalPriceIsofin || 0) > 0) score += 1;
    return score;
  }

  function normalizeAnalysis(raw) {
    if (!raw || typeof raw !== 'object') return null;
    var out = {};
    for (var k in raw) {
      if (Object.prototype.hasOwnProperty.call(raw, k)) out[k] = raw[k];
    }
    var bottles = Number(out.calculatedBottles || out.bottles || out.bottleCount || 0);
    if (!Number.isFinite(bottles) || bottles <= 0) return null;
    out.calculatedBottles = bottles;
    if (!(Number(out.bottles) > 0)) out.bottles = bottles;
    if (!(Number(out.bottleCount) > 0)) out.bottleCount = bottles;

    if (!(Number(out.drillSpacingCm) > 0) && Number(out.spacing) > 0) {
      out.drillSpacingCm = Number(out.spacing);
    }
    if (!(Number(out.drillAngleDeg) > 0) && Number(out.angle) > 0) {
      out.drillAngleDeg = Number(out.angle);
    }
    if (!(Number(out.wallThicknessCm) > 0) && Number(out.wallThickness) > 0) {
      out.wallThicknessCm = Number(out.wallThickness);
    }
    if (!(Number(out.drillDepthCm) > 0) && Number(out.drillDepth) > 0) {
      out.drillDepthCm = Number(out.drillDepth);
    }
    if (!hasCompleteAnalysis(out)) return null;
    return out;
  }

  /* v229.6: TTL — 7-Tage-Cap auf gespeicherte Berechnung.
     Born-Timestamp tracked via Fingerprint. Wenn Analyse > 7d alt → purge alle ISOWIZ-Keys.
     Greift beim Polling (alle 2.5s) → auto-cleanup ohne User-Action. */
  var ISOWIZ_TTL_MS = 7 * 24 * 60 * 60 * 1000;
  var ISOWIZ_BORN_KEY = '__ISOWIZ_ANALYSIS_BORN__';
  var ISOWIZ_PURGE_KEYS = [
    '__ISOWIZ__::analysis', '__ISOWIZ__::calcState',
    '__ISOWIZ_TEST__::analysis', '__ISOWIZ_TEST__::calcState',
    'isofinAnalysis', 'isofinCalcState',
    '__ISOWIZ_RESUME_ANALYSIS__', '__ISOWIZ_RESUME_STEP4_ONCE__',
    '__ISOWIZ_RESUME_STEP__', '__ISOWIZ_RETURN_TO_STEP4__',
    'isowiz_step4_completedSignature', STICKY_PANEL_ANALYSIS_KEY
  ];
  function _analysisFingerprint(a) {
    if (!a || typeof a !== 'object') return '';
    return [
      Number(a.calculatedBottles || a.bottles || 0),
      Number(a.holeCount || 0),
      Number(a.wallLengthM || 0),
      Number(a.surfaceLengthM || 0),
      Number(a.surfaceHeightM || 0),
      String(a.masonryType || ''),
      String(a.moistureType || '')
    ].join('|');
  }
  function _purgeAllIsoWizKeys() {
    for (var i = 0; i < ISOWIZ_PURGE_KEYS.length; i++) {
      try { localStorage.removeItem(ISOWIZ_PURGE_KEYS[i]); } catch (_) {}
      try { sessionStorage.removeItem(ISOWIZ_PURGE_KEYS[i]); } catch (_) {}
    }
    try { localStorage.removeItem(ISOWIZ_BORN_KEY); } catch (_) {}
  }
  function _checkTTLAndMaybePurge() {
    try {
      var raw = localStorage.getItem(ISOWIZ_BORN_KEY);
      if (!raw) return false;
      var ts = parseInt(String(raw).split('::')[0], 10);
      if (!isFinite(ts) || ts <= 0) return false;
      if (Date.now() - ts > ISOWIZ_TTL_MS) {
        _purgeAllIsoWizKeys();
        return true;
      }
      return false;
    } catch (_) { return false; }
  }
  function _maintainBornTS(analysis) {
    try {
      var fp = _analysisFingerprint(analysis);
      if (!fp || fp === '0|0|0|0|0||') return;
      var cur = localStorage.getItem(ISOWIZ_BORN_KEY) || '';
      var parts = cur.split('::');
      var curFp = parts.length > 1 ? parts.slice(1).join('::') : '';
      if (curFp !== fp) {
        localStorage.setItem(ISOWIZ_BORN_KEY, Date.now() + '::' + fp);
      }
    } catch (_) {}
  }

  function readStoredAnalysis() {
    /* v229.6: TTL-Check zuerst — wenn > 7d alt, alles purgen */
    if (_checkTTLAndMaybePurge()) return null;

    var candidates = [];

    var directAnalysis = window.isofinCalculatorData && window.isofinCalculatorData.analysis;
    if (directAnalysis && typeof directAnalysis === 'object') candidates.push(directAnalysis);

    var stickySnapshot = readStorageJSONCandidates(STICKY_PANEL_ANALYSIS_KEY);
    for (var s0 = 0; s0 < stickySnapshot.length; s0++) candidates.push(stickySnapshot[s0]);

    var fromStorageModule = readStorageModuleJSON('analysis');
    if (fromStorageModule) candidates.push(fromStorageModule);
    var fromStorageModuleCalc = readStorageModuleJSON('calcState');
    if (fromStorageModuleCalc) candidates.push(fromStorageModuleCalc);

    var fromNamespaced = readNamespacedJSONCandidates('analysis');
    for (var n1 = 0; n1 < fromNamespaced.length; n1++) candidates.push(fromNamespaced[n1]);
    var fromNamespacedCalc = readNamespacedJSONCandidates('calcState');
    for (var n2 = 0; n2 < fromNamespacedCalc.length; n2++) candidates.push(fromNamespacedCalc[n2]);

    var legacyAnalysis = readStorageJSONCandidates('isofinAnalysis');
    for (var l1 = 0; l1 < legacyAnalysis.length; l1++) candidates.push(legacyAnalysis[l1]);
    var resumeAnalysis = readStorageJSONCandidates('__ISOWIZ_RESUME_ANALYSIS__');
    for (var r1 = 0; r1 < resumeAnalysis.length; r1++) candidates.push(resumeAnalysis[r1]);
    var resumeStep4Once = readStorageJSONCandidates('__ISOWIZ_RESUME_STEP4_ONCE__');
    for (var r2 = 0; r2 < resumeStep4Once.length; r2++) candidates.push(resumeStep4Once[r2]);
    var legacyCalcState = readStorageJSONCandidates('isofinCalcState');
    for (var l2 = 0; l2 < legacyCalcState.length; l2++) candidates.push(legacyCalcState[l2]);

    var iwCalc = window.IsoWiz && window.IsoWiz.Calculations;
    if (iwCalc && typeof iwCalc.loadAnalysisFromStorage === 'function') {
      try {
        var loaded = iwCalc.loadAnalysisFromStorage();
        if (loaded && typeof loaded === 'object') candidates.push(loaded);
      } catch (_) {}
    }
    if (iwCalc && typeof iwCalc.loadCalcStateFromStorage === 'function') {
      try {
        var loadedCalcState = iwCalc.loadCalcStateFromStorage();
        if (loadedCalcState && typeof loadedCalcState === 'object') candidates.push(loadedCalcState);
      } catch (_) {}
    }

    var best = null;
    var bestScore = -1;
    for (var i = 0; i < candidates.length; i++) {
      var normalized = normalizeAnalysis(candidates[i]);
      if (!normalized) continue;
      var score = scoreAnalysisCandidate(normalized);
      if (score > bestScore) {
        bestScore = score;
        best = normalized;
      }
    }

    /* v229.6: Born-TS pflegen — bei neuer Berechnung Fingerprint-Wechsel erkannt */
    if (best) _maintainBornTS(best);

    return best;
  }

  function readStoredAnalysisNormalized() {
    return readStoredAnalysis();
  }

  function shouldPersistAnalysis(analysis) {
    if (!analysis || typeof analysis !== 'object') return false;
    if (Number(analysis.holeCount || 0) > 0 && Number(analysis.drillDepthCm || analysis.drillDepth || 0) > 0) return true;
    if (Number(analysis.wallThicknessCm || analysis.wallThickness || 0) > 0 && String(analysis.masonryType || '').trim()) return true;
    if (Number(analysis.totalPriceIsofin || 0) > 0) return true;
    return false;
  }

  function persistAnalysis(analysis) {
    if (!analysis) return;
    try {
      var payload = JSON.stringify(analysis);
      localStorage.setItem('isofinAnalysis', payload);
      sessionStorage.setItem('isofinAnalysis', payload);
      localStorage.setItem('__ISOWIZ_RESUME_ANALYSIS__', payload);
      sessionStorage.setItem('__ISOWIZ_RESUME_ANALYSIS__', payload);
    } catch (_) {}
  }

  function ensurePanelAnalysisContext() {
    var stored = readStoredAnalysisNormalized();
    if (!stored) return false;

    if (shouldPersistAnalysis(stored)) {
      persistAnalysis(stored);
    }

    if (!window.isofinCalculatorData || typeof window.isofinCalculatorData !== 'object') {
      window.isofinCalculatorData = {};
    }
    window.isofinCalculatorData.analysis = stored;

    var iw = (window.IsoWiz = window.IsoWiz || {});
    iw.Calculations = iw.Calculations || {};

    var currentGet = iw.Calculations.getFinalAnalysis;
    var bridgeFn = iw.Calculations.__sw2BridgeGetFinalAnalysis__;
    if (typeof bridgeFn !== 'function' || currentGet !== bridgeFn) {
      iw.Calculations.__sw2LiveGetFinalAnalysis__ =
        typeof currentGet === 'function' ? currentGet : null;

      iw.Calculations.__sw2BridgeGetFinalAnalysis__ = function() {
        var live = null;
        var liveFn = iw.Calculations.__sw2LiveGetFinalAnalysis__;
        if (typeof liveFn === 'function' && liveFn !== iw.Calculations.__sw2BridgeGetFinalAnalysis__) {
          try { live = liveFn(); } catch (_) {}
        }
        var normalizedLive = normalizeAnalysis(live);
        if (normalizedLive) {
          if (shouldPersistAnalysis(normalizedLive)) persistAnalysis(normalizedLive);
          return normalizedLive;
        }
        var normalizedStored = readStoredAnalysisNormalized();
        if (normalizedStored) {
          if (shouldPersistAnalysis(normalizedStored)) persistAnalysis(normalizedStored);
          return normalizedStored;
        }
        return null;
      };

      iw.Calculations.getFinalAnalysis = iw.Calculations.__sw2BridgeGetFinalAnalysis__;
    }

    return true;
  }

  function hasStoredResult() {
    var a = readStoredAnalysisNormalized();
    if (!a) return false;
    return hasCompleteAnalysis(a);
  }

  function hasStep4Marker() {
    var signatures = readStorageAll('isowiz_step4_completedSignature');
    for (var i = 0; i < signatures.length; i++) {
      if (signatures[i]) return true;
    }

    var returnFlags = readStorageAll('__ISOWIZ_RETURN_TO_STEP4__');
    for (var j = 0; j < returnFlags.length; j++) {
      if (String(returnFlags[j] || '') === '1') return true;
    }

    var steps = readStorageAll('__ISOWIZ_RESUME_STEP__');
    for (var k = 0; k < steps.length; k++) {
      var step = String(steps[k] || '').toLowerCase();
      if (step === '4' || step === 'step-4' || step === 'step4') return true;
    }
    return false;
  }

  function isPanelEligible(cart) {
    return bottleCount(cart) > 0 && hasStoredResult() && hasStep4Marker();
  }

  function getAssetBaseUrl() {
    if (window.ISOWIZ_ASSETS_BASE) return window.ISOWIZ_ASSETS_BASE;
    var base = '';
    try {
      var nodes = document.querySelectorAll('script[src*="/assets/"],link[href*="/assets/"]');
      for (var i = 0; i < nodes.length; i++) {
        var u = nodes[i].src || nodes[i].href;
        if (!u) continue;
        var m = u.match(/^(https?:\/\/[^/]+\/cdn\/shop\/t\/\d+\/assets\/)/);
        if (m) { base = m[1]; break; }
        m = u.match(/^(https?:\/\/[^/]+\/s\/files\/\d+\/\d+\/t\/\d+\/assets\/)/);
        if (m) { base = m[1]; break; }
      }
    } catch (_) {}
    if (!base && window.Shopify && window.Shopify.theme && window.Shopify.theme.id) {
      base = window.location.origin + '/cdn/shop/t/' + window.Shopify.theme.id + '/assets/';
    }
    if (base) window.ISOWIZ_ASSETS_BASE = base;
    return base;
  }

  function loadScriptWithFallback(primaryUrl, fallbackUrl, cacheKey) {
    if (SCRIPT_PROMISES[cacheKey]) return SCRIPT_PROMISES[cacheKey];
    SCRIPT_PROMISES[cacheKey] = new Promise(function(resolve, reject) {
      var triedFallback = false;
      function mount(url) {
        var s = document.createElement('script');
        s.src = url;
        s.async = true;
        s.onload = function() { resolve(); };
        s.onerror = function() {
          s.remove();
          if (!triedFallback && fallbackUrl) {
            triedFallback = true;
            mount(fallbackUrl);
            return;
          }
          reject(new Error('Script load failed: ' + url));
        };
        document.head.appendChild(s);
      }
      mount(primaryUrl);
    });
    return SCRIPT_PROMISES[cacheKey];
  }

  function installPreactCompat() {
    var preactLib = window.preact;
    var hooksLib = window.preactHooks;
    if (!preactLib || !hooksLib) return false;
    var ReactCompat = window.React || {};
    ReactCompat.createElement = preactLib.h;
    ReactCompat.Fragment = preactLib.Fragment;
    ReactCompat.useState = hooksLib.useState;
    ReactCompat.useEffect = hooksLib.useEffect;
    ReactCompat.useRef = hooksLib.useRef;
    ReactCompat.useMemo = hooksLib.useMemo || ReactCompat.useMemo;
    ReactCompat.useCallback = hooksLib.useCallback || ReactCompat.useCallback;
    ReactCompat.useLayoutEffect = hooksLib.useLayoutEffect || ReactCompat.useLayoutEffect;
    window.React = ReactCompat;
    if (!window.ReactDOM) window.ReactDOM = {};
    if (typeof window.ReactDOM.render !== 'function') {
      window.ReactDOM.render = function(vnode, container) { preactLib.render(vnode, container); return vnode; };
    }
    if (typeof window.ReactDOM.createRoot !== 'function') {
      window.ReactDOM.createRoot = function(container) {
        return {
          render: function(vnode) { preactLib.render(vnode, container); },
          unmount: function() { preactLib.render(null, container); }
        };
      };
    }
    if (typeof window.ReactDOM.unmountComponentAtNode !== 'function') {
      window.ReactDOM.unmountComponentAtNode = function(container) { preactLib.render(null, container); return true; };
    }
    return true;
  }

  function ensurePreactCompat() {
    if (window.React && typeof window.React.createElement === 'function' &&
        window.ReactDOM && (typeof window.ReactDOM.render === 'function' || typeof window.ReactDOM.createRoot === 'function')) {
      return Promise.resolve();
    }
    if (installPreactCompat()) return Promise.resolve();
    if (PREACT_COMPAT_PROMISE) return PREACT_COMPAT_PROMISE;
    PREACT_COMPAT_PROMISE = loadScriptWithFallback(
      'https://cdn.jsdelivr.net/npm/preact@10.26.4/dist/preact.umd.js',
      'https://unpkg.com/preact@10.26.4/dist/preact.umd.js',
      'preact-umd-10.26.4'
    ).then(function() {
      return loadScriptWithFallback(
        'https://cdn.jsdelivr.net/npm/preact@10.26.4/hooks/dist/hooks.umd.js',
        'https://unpkg.com/preact@10.26.4/hooks/dist/hooks.umd.js',
        'preact-hooks-umd-10.26.4'
      );
    }).then(function() {
      if (!installPreactCompat()) throw new Error('Preact compat install failed');
    });
    return PREACT_COMPAT_PROMISE;
  }

  function ensureAssetScript(filename) {
    var base = getAssetBaseUrl();
    if (!base) return Promise.reject(new Error('Asset base not found'));
    var version = encodeURIComponent(String(window.ISOWIZ_VERSION || Date.now()));
    var url = base + filename + '?v=' + version;
    return loadScriptWithFallback(url, null, 'asset:' + filename);
  }

  function ensurePanelRuntime(key) {
    var panelFile = CFG.PANEL_BOOT_FILES[key];
    if (!panelFile) return Promise.reject(new Error('Unknown panel key: ' + key));
    return ensurePreactCompat()
      .then(function() { return ensureAssetScript(CFG.PANEL_BOOT_FILES.sec03); })
      .then(function() {
        var inj = window.__ISOWIZ_STEP4_CSS_INJECTORS__ && window.__ISOWIZ_STEP4_CSS_INJECTORS__.sec03v2;
        if (typeof inj === 'function') {
          try { inj(); } catch (_) {}
        }
      })
      .then(function() { return ensureAssetScript(panelFile); });
  }

  /* ═══════════════════════════════════════════════════════════════════════
     CSS
  ═══════════════════════════════════════════════════════════════════════ */
  var CSS = `
#isofin-sw2-bar,
#isofin-sw2-bar *,
#isofin-sw2-menu *,
#isofin-sw2-overlay,
#isofin-sw2-modal-overlay,
.isofin-sw2-detail *,
.isofin-sw2-modal * {
  box-sizing: border-box !important;
}

/* ── VARIABLES ── */
#isofin-sw2-bar {
  --sw2-primary: #D6001C;
  --sw2-primary-dark: #A80016;
  --sw2-text: #202325;
  --sw2-muted: #5c636a;
  --sw2-border: rgba(0,0,0,0.08);
  --sw2-white: #ffffff;
  --sw2-ease: 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

/* ── STICKY BAR ── */
#isofin-sw2-bar {
  position: fixed !important;
  bottom: 0 !important; left: 0 !important; width: 100% !important;
  background: #fff !important;
  border-top: 1px solid rgba(0,0,0,0.08) !important;
  box-shadow: 0 -8px 32px rgba(0,0,0,0.06) !important;
  z-index: 9000 !important;
  padding: 10px 16px !important;
  padding-bottom: calc(10px + env(safe-area-inset-bottom, 0)) !important;
  display: flex !important; justify-content: space-between !important;
  align-items: center !important; gap: 12px !important;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
  transition: 0.4s cubic-bezier(0.16,1,0.3,1) !important;
}
#isofin-sw2-bar::after {
  content: '' !important; position: absolute !important;
  left: 0 !important; right: 0 !important; top: 100% !important;
  height: 300px !important; background: #fff !important; pointer-events: none !important;
}
#isofin-sw2-bar.sw2-anim-in {
  animation: sw2BarInMobile .36s cubic-bezier(0.16,1,0.3,1) both !important;
}
@keyframes sw2BarInMobile {
  0% { opacity: 0; transform: translateY(18px); }
  100% { opacity: 1; transform: translateY(0); }
}
@media (min-width: 768px) {
  #isofin-sw2-bar::after { display: none !important; }
  #isofin-sw2-bar.sw2-anim-in {
    animation: sw2BarInDesktop .36s cubic-bezier(0.16,1,0.3,1) both !important;
  }
  @keyframes sw2BarInDesktop {
    0% { opacity: 0; transform: translateX(-50%) translateY(16px); }
    100% { opacity: 1; transform: translateX(-50%) translateY(0); }
  }
}

.sw2-plan-btn {
  display: inline-flex !important; align-items: center !important; gap: 8px !important;
  background: transparent !important; border: none !important; padding: 8px 4px !important;
  font-size: 15px !important; font-weight: 600 !important; color: #202325 !important;
  cursor: pointer !important; transition: opacity .2s !important;
  font-family: inherit !important; white-space: nowrap !important;
}
.sw2-plan-btn:hover { opacity: .65 !important; }

.sw2-cta {
  display: flex !important; align-items: center !important;
  justify-content: center !important; gap: 8px !important;
  background: linear-gradient(180deg, #D6001C 0%, #A80016 100%) !important;
  color: #fff !important; border: none !important; border-radius: 12px !important;
  padding: 13px 22px !important; font-size: 15px !important; font-weight: 700 !important;
  cursor: pointer !important; white-space: nowrap !important; font-family: inherit !important;
  box-shadow: inset 0 -2px 0 rgba(0,0,0,.15), 0 2px 8px rgba(214,0,28,.2) !important;
  transition: transform .2s ease, filter .2s ease !important;
  text-decoration: none !important; position: relative !important;
  text-shadow: 0 1px 2px rgba(0,0,0,.25) !important;
  flex-shrink: 0 !important;
}
.sw2-cta:hover { transform: translateY(-2px) !important; filter: brightness(1.08) !important; }
.sw2-cta.is-empty { }
.sw2-cta.is-empty::before {
  content: '' !important; position: absolute !important;
  top: -50% !important; left: -50% !important; width: 200% !important; height: 200% !important;
  background: linear-gradient(45deg,transparent 30%,rgba(255,255,255,.15) 50%,transparent 70%) !important;
  transform: translateX(-100%) translateY(-100%) rotate(45deg) !important;
  animation: sw2-shine 3s ease-in-out infinite !important;
  clip-path: inset(0 round 12px) !important;
}
.sw2-cta-arrow {
  display: inline-block !important; margin-left: 2px !important;
  animation: sw2-arrow 1.5s ease-in-out infinite !important;
}
.sw2-cta.is-empty:hover .sw2-cta-arrow { transform: translateX(6px) !important; animation: none !important; }
.sw2-fl { font-weight: 400 !important; font-size: .88em !important; opacity: .85 !important; }

@keyframes sw2-shine {
  0%   { transform: translateX(-100%) translateY(-100%) rotate(45deg); }
  50%  { transform: translateX(100%)  translateY(100%)  rotate(45deg); }
  100% { transform: translateX(100%)  translateY(100%)  rotate(45deg); }
}
@keyframes sw2-arrow  { 0%,100%{transform:translateX(0);opacity:.9;} 50%{transform:translateX(5px);opacity:1;} }

/* Desktop: Floating Pill */
@media (min-width: 768px) {
  #isofin-sw2-bar {
    width: auto !important;
    bottom: 28px !important;
    left: 50% !important; transform: translateX(-50%) !important;
    border-radius: 100px !important;
    border: 1px solid rgba(0,0,0,0.08) !important;
    box-shadow: 0 12px 32px rgba(0,0,0,.12) !important;
    padding: 8px 10px 8px 24px !important; gap: 20px !important;
  }
  #isofin-sw2-bar.sw2-bar--empty {
    width: 90% !important; max-width: 1400px !important;
    padding: 8px 10px 8px 32px !important;
  }
  .sw2-cta { border-radius: 100px !important; padding: 11px 26px !important; }
}
@media (min-width: 1024px) {
  #isofin-sw2-bar.sw2-bar--empty { width: 70% !important; }
}

/* Responsive label hiding */
@media (max-width: 400px) { .sw2-zur { display: none !important; } }
@media (max-width: 340px) { .sw2-fl-wrap { display: none !important; } }

@media (max-width: 767px) {
  #isofin-sw2-bar.sw2-bar--empty {
    justify-content: center !important;
  }
}

/* Empty state intro text – tablet + desktop only (≥641px), like V1 */
.sw2-empty-text {
  display: none !important;
  font-size: 14px !important; line-height: 1.4 !important;
  color: #202325 !important; opacity: 0.9; font-weight: 500 !important;
  max-width: 600px !important; flex: 1 !important;
}
.sw2-empty-text strong { font-weight: 700 !important; color: #D6001C !important; }
@media (min-width: 641px) {
  #isofin-sw2-bar.sw2-bar--empty .sw2-empty-text { display: block !important; }
}

/* ── OVERLAY (shared) ── */
#isofin-sw2-overlay,
#isofin-sw2-modal-overlay {
  position: fixed !important; inset: 0 !important;
  background: rgba(0,0,0,.45) !important;
  backdrop-filter: blur(4px) !important; -webkit-backdrop-filter: blur(4px) !important;
  opacity: 0 !important; visibility: hidden !important;
  transition: opacity .4s cubic-bezier(0.16,1,0.3,1), visibility .4s !important;
}
#isofin-sw2-overlay   { z-index: 9998 !important; }
#isofin-sw2-modal-overlay { z-index: 10000 !important; }
#isofin-sw2-overlay.is-open,
#isofin-sw2-modal-overlay.is-open { opacity: 1 !important; visibility: visible !important; }

/* ── MENU: BOTTOM SHEET (mobile) / SIDE PANEL (desktop) ── */
#isofin-sw2-menu {
  position: fixed !important; bottom: 0 !important; left: 0 !important; width: 100% !important;
  background: #fff !important;
  border-radius: 24px 24px 0 0 !important;
  box-shadow: 0 -12px 48px rgba(0,0,0,.15) !important;
  z-index: 9999 !important;
  transform: translateY(100%) !important;
  transition: transform .4s cubic-bezier(0.16,1,0.3,1) !important;
  display: flex !important; flex-direction: column !important;
  overflow: hidden !important; max-height: 75vh !important;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
}
#isofin-sw2-menu.is-open { transform: translateY(0) !important; }

.sw2-handle {
  width: 40px !important; height: 4px !important; background: #dee2e6 !important;
  border-radius: 4px !important; margin: 12px auto 0 !important; flex-shrink: 0 !important;
}
.sw2-menu-header {
  display: flex !important; align-items: center !important;
  justify-content: space-between !important;
  padding: 16px 20px 12px !important; flex-shrink: 0 !important;
}
.sw2-menu-title { font-size: 18px !important; font-weight: 700 !important; color: #202325 !important; }
.sw2-menu-sub   { font-size: 13px !important; color: #5c636a !important; margin-top: 2px !important; }
.sw2-icon-btn {
  width: 32px !important; height: 32px !important; border-radius: 50% !important;
  background: #f1f3f5 !important; border: none !important;
  display: flex !important; align-items: center !important; justify-content: center !important;
  font-size: 18px !important; color: #5c636a !important; cursor: pointer !important;
  transition: background .15s !important; font-family: inherit !important;
  flex-shrink: 0 !important;
}
.sw2-icon-btn:hover { background: #e2e2e2 !important; color: #202325 !important; }

.sw2-menu-body { padding: 0 16px 24px !important; overflow-y: auto !important; }
.sw2-menu-list { display: flex !important; flex-direction: column !important; gap: 8px !important; list-style: none !important; width: 100% !important; margin: 0 !important; padding: 0 !important; }
.sw2-menu-item {
  display: flex !important; align-items: center !important; gap: 14px !important;
  width: 100% !important;
  padding: 15px 16px !important; background: #fff !important;
  border: 1px solid rgba(0,0,0,0.08) !important; border-radius: 12px !important;
  cursor: pointer !important; transition: all .18s !important; text-decoration: none !important;
  color: #202325 !important;
}
.sw2-menu-item:hover {
  border-color: #aaa !important;
  box-shadow: 0 4px 12px rgba(0,0,0,.06) !important;
  transform: translateY(-1px) !important;
}
.sw2-mi-icon  { font-size: 22px !important; width: 48px !important; text-align: center !important; flex-shrink: 0 !important; }
.sw2-mi-thumb {
  width: 48px !important; height: 48px !important; border-radius: 8px !important;
  object-fit: cover !important; flex-shrink: 0 !important;
  border: 1px solid rgba(0,0,0,0.06) !important;
}
.sw2-mi-text  { flex: 1 !important; }
.sw2-mi-main  { font-size: 15px !important; font-weight: 600 !important; display: block !important; margin-bottom: 2px !important; color: #202325 !important; }
.sw2-mi-sub   { font-size: 12px !important; color: #5c636a !important; display: block !important; }
.sw2-mi-arrow { color: #aaa !important; font-size: 18px !important; flex-shrink: 0 !important; }

/* Desktop: Side Panel */
@media (min-width: 768px) {
  #isofin-sw2-menu {
    top: 0 !important; bottom: 0 !important;
    left: auto !important; right: 0 !important;
    width: 420px !important; max-height: 100vh !important; height: 100% !important;
    border-radius: 0 !important;
    transform: translateX(100%) !important;
  }
  #isofin-sw2-menu.is-open { transform: translateX(0) !important; }
  .sw2-handle { display: none !important; }
  .sw2-menu-header { padding: 20px 24px 16px !important; border-bottom: 1px solid rgba(0,0,0,0.08) !important; }
  .sw2-menu-body { padding: 16px 16px 26px !important; }
  .sw2-menu-list { width: 100% !important; }
  .sw2-menu-item {
    width: 100% !important;
    min-height: 72px !important;
    padding: 16px 18px !important;
  }
  .sw2-mi-arrow {
    order: -1 !important;
    margin-right: 10px !important;
    margin-left: 0 !important;
    width: 18px !important;
    text-align: center !important;
    transform: rotate(180deg) !important;
  }
}

/* ── DETAIL SCREENS (Mobile fullscreen, slide from right) ── */
.sw2-detail {
  position: fixed !important; inset: 0 !important;
  background: #fff !important; z-index: 10000 !important;
  display: flex !important; flex-direction: column !important;
  transform: translateX(100%) !important;
  transition: transform .4s cubic-bezier(0.16,1,0.3,1), visibility .4s !important;
  visibility: hidden !important;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
}
.sw2-detail.is-open { transform: translateX(0) !important; visibility: visible !important; }

.sw2-detail-header {
  display: flex !important; align-items: center !important;
  justify-content: space-between !important;
  padding: 12px 20px !important; border-bottom: 1px solid rgba(0,0,0,0.08) !important;
  background: #FAFAFA !important; flex-shrink: 0 !important;
}
.sw2-back-btn {
  display: flex !important; align-items: center !important; gap: 5px !important;
  background: none !important; border: none !important; font-family: inherit !important;
  font-size: 14px !important; font-weight: 600 !important; color: #202325 !important;
  cursor: pointer !important; padding: 8px 8px 8px 0 !important;
  border-radius: 8px !important; transition: opacity .15s !important;
}
.sw2-back-btn:hover { opacity: .65 !important; }

.sw2-detail-scroll {
  flex: 1 !important; overflow-y: auto !important;
  -webkit-overflow-scrolling: touch !important; padding: 0 20px 20px !important;
}
.sw2-detail-title-wrap { padding: 20px 0 12px !important; text-align: center !important; }
.sw2-detail-title    { font-size: 20px !important; font-weight: 700 !important; color: #111827 !important; margin: 0 0 6px !important; line-height: 1.3 !important; }
.sw2-detail-subtitle { font-size: 14px !important; color: #6B7280 !important; margin: 0 !important; line-height: 1.5 !important; }
.sw2-panel-mount { /* panel content lands here */ }

.sw2-detail-footer {
  padding: 10px 16px !important; border-top: 1px solid rgba(0,0,0,0.08) !important;
  background: #fff !important; box-shadow: 0 -2px 8px rgba(0,0,0,.06) !important;
  flex-shrink: 0 !important;
}
.sw2-footer-cta {
  width: 100% !important; display: flex !important; flex-direction: column !important;
  align-items: center !important; justify-content: center !important; gap: 3px !important;
  background: linear-gradient(135deg, #C8102E 0%, #a00d25 100%) !important;
  color: #fff !important; border: none !important; border-radius: 12px !important;
  padding: 12px 20px !important; cursor: pointer !important; font-family: inherit !important;
  box-shadow: 0 4px 12px rgba(200,16,46,.3) !important;
  transition: transform .15s, box-shadow .15s !important;
}
.sw2-footer-cta:hover { transform: translateY(-2px) !important; box-shadow: 0 6px 16px rgba(200,16,46,.4) !important; }
.sw2-fcta-main { font-size: 15px !important; font-weight: 700 !important; color: #fff !important; }
.sw2-fcta-sub  { font-size: 11px !important; opacity: .9 !important; color: #fff !important; }

/* Loading state */
.sw2-panel-loading {
  padding: 40px 20px !important; text-align: center !important;
  color: #6B7280 !important; font-size: 14px !important;
}
.sw2-panel-error {
  border: 1px solid rgba(214,0,28,.18) !important;
  background: #fff6f7 !important;
  border-radius: 14px !important;
  padding: 16px !important;
  margin-top: 8px !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 10px !important;
}
.sw2-panel-error-title {
  font-size: 15px !important;
  font-weight: 700 !important;
  color: #7f1d1d !important;
  line-height: 1.35 !important;
}
.sw2-panel-error-text {
  font-size: 13px !important;
  color: #5c636a !important;
  line-height: 1.5 !important;
}
.sw2-panel-error-cta {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
  padding: 11px 14px !important;
  border-radius: 10px !important;
  background: #D6001C !important;
  color: #fff !important;
  text-decoration: none !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  border: none !important;
  cursor: pointer !important;
}
.sw2-panel-error-cta:hover { filter: brightness(1.08) !important; }

/* Only show detail screens on mobile */
@media (min-width: 768px) { .sw2-detail { display: none !important; } }

/* ── DESKTOP MODALS ── */
.sw2-modal {
  position: fixed !important; top: 50% !important; left: 50% !important;
  transform: translate(-50%, -50%) scale(0.95) !important;
  width: 90% !important; max-width: 620px !important; max-height: 88vh !important;
  background: #fff !important; border-radius: 16px !important;
  box-shadow: 0 25px 50px -12px rgba(0,0,0,.25) !important;
  z-index: 10001 !important;
  display: none !important; flex-direction: column !important;
  opacity: 0 !important; visibility: hidden !important;
  transition: transform .35s cubic-bezier(0.16,1,0.3,1), opacity .35s, visibility .35s !important;
  overflow: hidden !important;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
}
@media (min-width: 768px) { .sw2-modal { display: flex !important; } }
.sw2-modal.is-open {
  opacity: 1 !important; visibility: visible !important;
  transform: translate(-50%, -50%) scale(1) !important;
}
.sw2-modal-header {
  display: flex !important; align-items: center !important;
  justify-content: space-between !important;
  padding: 12px 20px !important; border-bottom: 1px solid rgba(0,0,0,0.08) !important;
  background: #FAFAFA !important; flex-shrink: 0 !important;
}
.sw2-modal-back {
  background: none !important; border: none !important; font-family: inherit !important;
  font-size: 14px !important; font-weight: 500 !important; color: #374151 !important;
  cursor: pointer !important; padding: 8px 10px !important; margin: -8px 0 -8px -10px !important;
  border-radius: 8px !important; display: flex !important; align-items: center !important; gap: 4px !important;
  transition: background .15s !important;
}
.sw2-modal-back:hover { background: #eee !important; }
.sw2-modal-close {
  width: 36px !important; height: 36px !important; border-radius: 50% !important;
  background: none !important; border: none !important; font-size: 22px !important;
  color: #6B7280 !important; cursor: pointer !important;
  display: flex !important; align-items: center !important; justify-content: center !important;
  margin: -8px -8px -8px 0 !important; font-family: inherit !important;
  transition: background .15s !important;
}
.sw2-modal-close:hover { background: #eee !important; color: #111 !important; }
.sw2-modal-scroll {
  flex: 1 !important; overflow-y: auto !important;
  -webkit-overflow-scrolling: touch !important; padding: 0 20px 20px !important;
}
.sw2-modal-footer {
  padding: 10px 16px !important; border-top: 1px solid rgba(0,0,0,0.08) !important;
  background: #fff !important; box-shadow: 0 -2px 8px rgba(0,0,0,.06) !important;
  flex-shrink: 0 !important;
}

/* Detail screens + modals are handled entirely by sec-03's own drawer system.
   No additional CSS needed here for panel content. */
`;

  /* ═══════════════════════════════════════════════════════════════════════
     HTML
  ═══════════════════════════════════════════════════════════════════════ */
  function buildHTML() {
    var menuItems = Object.keys(PANELS).map(function (key) {
      var p = PANELS[key];
      var iconEl = p.thumb
        ? '<img class="sw2-mi-thumb" src="' + p.thumb + '" alt="" loading="lazy">'
        : '<span class="sw2-mi-icon">' + p.icon + '</span>';
      return '<li class="sw2-menu-item" data-sw2-panel="' + key + '">' +
        iconEl +
        '<span class="sw2-mi-text">' +
        '<span class="sw2-mi-main">' + p.label + '</span>' +
        '<span class="sw2-mi-sub">' + p.sub + '</span>' +
        '</span>' +
        '<span class="sw2-mi-arrow">→</span>' +
        '</li>';
    }).join('');

    return '' +
      // Bar
      '<div id="isofin-sw2-bar" class="sw2-bar--empty" style="display:none !important">' +
      '<span class="sw2-empty-text"><strong>Isofin\u00ae</strong> \u2013 das Original aus deutscher Produktion bietet Ihnen lebenslange Sicherheit &amp; dauerhaft trockene W\u00e4nde.</span>' +
      '<button class="sw2-plan-btn" id="sw2-plan-btn" style="display:none" data-sw2-openmenu="1">' +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>' +
      '<polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>' +
      '</svg>' +
      'Sanierungsplan' +
      '</button>' +
      '<a class="sw2-cta is-empty" id="sw2-cta" href="' + CFG.HERO_ANCHOR_URL + '">' +
      'Sanierung berechnen <span class="sw2-cta-arrow">\u2192</span>' +
      '</a>' +
      '</div>' +
      // Overlay (menu only)
      '<div id="isofin-sw2-overlay"></div>' +
      // Menu
      '<div id="isofin-sw2-menu">' +
      '<div class="sw2-handle"></div>' +
      '<div class="sw2-menu-header">' +
      '<div><div class="sw2-menu-title">Sanierungsplan f\u00fcr Ihre Wand</div><div class="sw2-menu-sub" id="sw2-menu-sub">\u2013</div></div>' +
      '<button class="sw2-icon-btn" data-sw2-closemenu="1">\u00d7</button>' +
      '</div>' +
      '<div class="sw2-menu-body"><ul class="sw2-menu-list">' + menuItems +
      '<li class="sw2-menu-item" data-sw2-kalkulator="1">' +
      '<span class="sw2-mi-icon">\uD83D\uDD04</span>' +
      '<span class="sw2-mi-text">' +
      '<span class="sw2-mi-main">Zur\u00fcck zur Berechnung</span>' +
      '<span class="sw2-mi-sub">\u00dcbersicht erneut \u00f6ffnen</span>' +
      '</span>' +
      '<span class="sw2-mi-arrow">\u2192</span>' +
      '</li>' +
      '</ul></div>' +
      '</div>';
  }

  /* ═══════════════════════════════════════════════════════════════════════
     PANEL DELEGATION  (sec-03 owns the drawer UI, we just call its globals)
  ═══════════════════════════════════════════════════════════════════════ */

  // Map panel key → global function name registered by sec-03
  var PANEL_FN_MAP = {
    anleitung: 'openGuideModal',
    material: 'openWerkzeugModal',
    wirkung: 'openGarantieModal'
  };
  var PANEL_TRACK_EVENT_MAP = {
    anleitung: 'futa_panel_anleitung_click',
    material: 'futa_panel_material_click',
    wirkung: 'futa_panel_wirkung_click'
  };

  function trackLogr3(eventName, payload) {
    if (!eventName || typeof window.logr3Track !== 'function') return;
    try {
      window.logr3Track(eventName, payload || {});
    } catch (_) {}
  }

  function showPanelReloadHint() {
    var menuBody = document.querySelector('#isofin-sw2-menu .sw2-menu-body');
    var menuSub = document.getElementById('sw2-menu-sub');
    if (menuSub) menuSub.textContent = 'Berechnung neu starten erforderlich';
    if (!menuBody) {
      window.location.href = CFG.CALCULATOR_URL;
      return;
    }
    menuBody.innerHTML =
      '<div class="sw2-panel-error">' +
      '<div class="sw2-panel-error-title">Panel konnte nicht geladen werden</div>' +
      '<div class="sw2-panel-error-text">Bitte Berechnung erst neu starten. Danach steht der Sanierungsplan wieder vollständig zur Verfügung.</div>' +
      '<a class="sw2-panel-error-cta" href="' + CFG.CALCULATOR_URL + '">Berechnung neu starten</a>' +
      '</div>';
    openMenu();
  }

  function invokePanelFunction(key, fnName) {
    if (typeof window[fnName] !== 'function') return false;
    try {
      closeMenu();
      window[fnName]();
      trackLogr3(PANEL_TRACK_EVENT_MAP[key], {
        source: 'sticky_footer',
        panel_eligible: STATE.panelEligible ? 1 : 0,
        bottles: Number(STATE.lastBottleQty || 0)
      });
      return true;
    } catch (e) {
      console.warn('[SW2] Fehler beim Öffnen von ' + fnName + ':', e);
      return false;
    }
  }

  function callPanelFn(key) {
    var fnName = PANEL_FN_MAP[key];
    if (!fnName) return;

    if (!STATE.panelEligible) {
      showPanelReloadHint();
      return;
    }

    ensurePanelRuntime(key).then(function() {
      if (!ensurePanelAnalysisContext()) {
        showPanelReloadHint();
        return;
      }
      if (invokePanelFunction(key, fnName)) {
        return;
      }
      // Safety retry (late registration edge cases)
      var retries = 0;
      var iv = setInterval(function () {
        retries++;
        if (invokePanelFunction(key, fnName)) {
          clearInterval(iv);
        } else if (retries >= CFG.PANEL_RETRY_MAX) {
          clearInterval(iv);
          console.warn('[SW2] ' + fnName + ' nicht verfügbar nach ' + retries + ' Versuchen.');
          showPanelReloadHint();
        }
      }, CFG.PANEL_RETRY_MS);
    }).catch(function(err) {
      console.warn('[SW2] Panel-Laufzeit konnte nicht geladen werden:', err && err.message ? err.message : err);
      if (!ensurePanelAnalysisContext()) {
        showPanelReloadHint();
        return;
      }
      if (!invokePanelFunction(key, fnName)) showPanelReloadHint();
    });
  }

  /* ═══════════════════════════════════════════════════════════════════════
     UI ACTIONS
  ═══════════════════════════════════════════════════════════════════════ */
  function openMenu() {
    document.getElementById('isofin-sw2-menu').classList.add('is-open');
    document.getElementById('isofin-sw2-overlay').classList.add('is-open');
    document.body.classList.add('isofin-sw2-noscroll');
  }
  function closeMenu() {
    document.getElementById('isofin-sw2-menu').classList.remove('is-open');
    document.getElementById('isofin-sw2-overlay').classList.remove('is-open');
    document.body.classList.remove('isofin-sw2-noscroll');
  }
  function closeAll() {
    closeMenu();
    document.body.classList.remove('isofin-sw2-noscroll');
  }

  function smoothScrollToHero() {
    var hero = document.getElementById('hero');
    if (!hero) return false;
    try {
      hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return true;
    } catch (_) {
      window.location.hash = 'hero';
      return true;
    }
  }

  function consumePendingHeroScroll() {
    var pending = null;
    try { pending = sessionStorage.getItem(CFG.HERO_SCROLL_FLAG_KEY); } catch (_) {}
    if (!pending && window.location.hash !== '#hero') return;
    try { sessionStorage.removeItem(CFG.HERO_SCROLL_FLAG_KEY); } catch (_) {}
    setTimeout(function () { smoothScrollToHero(); }, 80);
  }

  function isMobileViewport() {
    try {
      if (window.matchMedia) return window.matchMedia('(max-width:' + CFG.MOBILE_MAX_WIDTH + 'px)').matches;
    } catch (_) {}
    return (window.innerWidth || 0) <= CFG.MOBILE_MAX_WIDTH;
  }

  function getScrollY() {
    return window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  function shouldShowWhenEmpty() {
    var threshold = isMobileViewport() ? CFG.MOBILE_EMPTY_THRESHOLD : CFG.DESKTOP_EMPTY_THRESHOLD;
    return getScrollY() > threshold;
  }

  /* v229.8 audit: applyStickyVisibility nur noch bei echten State-Wechseln aufrufen.
     Vorher: jeder Scroll → DOM-Read + ggf. void offsetWidth (forced reflow, ~81ms TBT auf Desktop).
     Jetzt: rAF-Throttle in onScrollOrResize() + Early-Exit hier. */
  var _stickyLastApplied = null;
  function applyStickyVisibility() {
    if (STATE.showSticky === _stickyLastApplied) return;
    var bar = document.getElementById('isofin-sw2-bar');
    if (!bar) return;
    _stickyLastApplied = STATE.showSticky;
    if (STATE.showSticky) {
      bar.style.setProperty('display', 'flex', 'important');
      bar.classList.remove('sw2-anim-in');
      void bar.offsetWidth;
      bar.classList.add('sw2-anim-in');
      bar.setAttribute('data-sw2-visible', '1');
      return;
    }
    bar.setAttribute('data-sw2-visible', '0');
    bar.classList.remove('sw2-anim-in');
    bar.style.setProperty('display', 'none', 'important');
  }

  function refreshStickyVisibility() {
    if (STATE.uiFilled) {
      STATE.showSticky = true;
    } else {
      STATE.showSticky = shouldShowWhenEmpty();
    }
    applyStickyVisibility();
  }

  /* v229.8 audit: rAF-Throttle für Scroll/Resize-Handler — max 1× pro Frame */
  var _stickyRafId = 0;
  function onStickyViewportChange() {
    if (_stickyRafId) return;
    _stickyRafId = requestAnimationFrame(function () {
      _stickyRafId = 0;
      refreshStickyVisibility();
    });
  }

  /* ═══════════════════════════════════════════════════════════════════════
     CART RENDERING
  ═══════════════════════════════════════════════════════════════════════ */
  function renderEmpty() {
    var planBtn = document.getElementById('sw2-plan-btn');
    var cta = document.getElementById('sw2-cta');
    var bar = document.getElementById('isofin-sw2-bar');
    if (!planBtn || !cta) return;

    STATE.lastBottleQty = 0;
    STATE.uiFilled = false;
    planBtn.style.setProperty('display', 'none', 'important');
    cta.className = 'sw2-cta is-empty';
    cta.href = CFG.HERO_ANCHOR_URL;
    cta.innerHTML = 'Sanierung berechnen <span class="sw2-cta-arrow">→</span>';
    if (bar) bar.classList.add('sw2-bar--empty');
    refreshStickyVisibility();
  }

  function renderFilled(cart, panelEligible) {
    var planBtn = document.getElementById('sw2-plan-btn');
    var cta = document.getElementById('sw2-cta');
    var menuSub = document.getElementById('sw2-menu-sub');
    var bar = document.getElementById('isofin-sw2-bar');
    if (!planBtn || !cta) return;

    var total = cart.total_price || 0;
    var bottles = bottleCount(cart);
    STATE.lastBottleQty = bottles;
    STATE.uiFilled = true;

    // Show Sanierungsplan whenever Isofin goods are in cart.
    // Panel opening itself remains gated by panel eligibility in callPanelFn().
    planBtn.style.setProperty('display', 'inline-flex', 'important');
    cta.className = 'sw2-cta';
    cta.href = CFG.CHECKOUT_URL;
    /* v229.8: Flaschenzahl im Sticky-CTA entfernt — nur "Zur Kasse · 149,90€" */
    cta.innerHTML =
      '<span class="sw2-zur">Zur </span>Kasse&nbsp;·&nbsp;' + fmt(total);
    if (bar) bar.classList.remove('sw2-bar--empty');

    if (menuSub && panelEligible && bottles > 0) {
      menuSub.textContent = bottles + ' Flaschen berechnet';
    } else if (menuSub) {
      menuSub.textContent = 'Panels nach Ergebnisberechnung verfügbar';
    }
    refreshStickyVisibility();
  }

  async function renderFromCart() {
    var cart = await fetchCart();
    if (!cart) return;

    var nextPanelEligible = isPanelEligible(cart);
    var token = tokenize(cart);
    var tokenChanged = token !== STATE.lastToken;
    var eligibilityChanged = nextPanelEligible !== STATE.panelEligible;
    if (!tokenChanged && !eligibilityChanged) return;
    STATE.lastToken = token;

    STATE.panelEligible = nextPanelEligible;
    if (bottleCount(cart) > 0) {
      renderFilled(cart, STATE.panelEligible);
    } else {
      renderEmpty();
    }
  }

  /* ═══════════════════════════════════════════════════════════════════════
     EVENT DELEGATION  (one listener for entire component)
  ═══════════════════════════════════════════════════════════════════════ */
  function attachEvents() {
    document.addEventListener('click', function (e) {
      var checkoutCta = e.target && e.target.closest('#sw2-cta');
      if (checkoutCta && !checkoutCta.classList.contains('is-empty')) {
        trackLogr3('futa_zur_kasse_click', {
          source: 'sticky_footer',
          bottles: Number(STATE.lastBottleQty || 0)
        });
      }

      var emptyCta = e.target && e.target.closest('#sw2-cta');
      if (emptyCta && emptyCta.classList.contains('is-empty')) {
        e.preventDefault();
        e.stopPropagation();
        if (window.location.pathname === '/') {
          if (!smoothScrollToHero()) window.location.assign(CFG.HERO_ANCHOR_URL);
          return;
        }
        try { sessionStorage.setItem(CFG.HERO_SCROLL_FLAG_KEY, '1'); } catch (_) {}
        window.location.assign('/');
        return;
      }

      var el = e.target && e.target.closest(
        '[data-sw2-openmenu],[data-sw2-closemenu],[data-sw2-panel],[data-sw2-kalkulator],[data-sw2-checkout]'
      );
      if (!el) return;

      if (el.dataset.sw2Openmenu) {
        trackLogr3('futa_sanierungsplan_click', {
          source: 'sticky_footer',
          bottles: Number(STATE.lastBottleQty || 0),
          panel_eligible: STATE.panelEligible ? 1 : 0
        });
        openMenu();
      }
      if (el.dataset.sw2Closemenu) closeMenu();
      if (el.dataset.sw2Panel) callPanelFn(el.dataset.sw2Panel);
      if (el.dataset.sw2Kalkulator) window.location.href = CFG.CALCULATOR_URL;
      if (el.dataset.sw2Checkout) window.location.href = CFG.CHECKOUT_URL;
    }, true);

    // Overlay closes menu
    var overlay = document.getElementById('isofin-sw2-overlay');
    if (overlay) overlay.addEventListener('click', closeMenu);

    // Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });

    // Cart mutation listeners
    var cartEvents = ['cart:refresh', 'cart:updated', 'ajaxCart:updated', 'product:added'];
    cartEvents.forEach(function (evt) {
      document.addEventListener(evt, function () {
        STATE.burstUntil = Date.now() + CFG.BURST_MS;
        renderFromCart();
      }, { passive: true });
    });

    // Intercept fetch/XHR cart mutations
    (function () {
      var _fetch = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var p = _fetch(input, init);
        if (/\/cart\/(add|update|change|clear)/.test(url)) {
          STATE.burstUntil = Date.now() + CFG.BURST_MS;
          p.then(function () { setTimeout(renderFromCart, 200); }).catch(function () { });
        }
        return p;
      };
    })();

    // Polling
    setInterval(renderFromCart, CFG.POLL_INTERVAL_MS);
    setInterval(function () {
      if (Date.now() < STATE.burstUntil) renderFromCart();
    }, CFG.BURST_TICK_MS);

    // Body overflow guard
    var style = document.createElement('style');
    style.textContent = 'body.isofin-sw2-noscroll { overflow: hidden !important; }';
    document.head.appendChild(style);

    // v229.8 audit: rAF-throttled Scroll/Resize-Handler (max 1× pro Frame)
    setTimeout(refreshStickyVisibility, 100);
    window.addEventListener('scroll', onStickyViewportChange, { passive: true });
    window.addEventListener('resize', onStickyViewportChange, { passive: true });
    window.addEventListener('orientationchange', function () {
      setTimeout(refreshStickyVisibility, 100);
    });
  }

  /* ═══════════════════════════════════════════════════════════════════════
     MOUNT
  ═══════════════════════════════════════════════════════════════════════ */
  function ensureMount() {
    if (!document.getElementById('isofin-sw2-bar')) {
      var wrap = document.createElement('div');
      wrap.innerHTML = buildHTML();
      while (wrap.firstChild) document.body.appendChild(wrap.firstChild);
    }
    if (!document.getElementById('sw2-styles')) {
      var style = document.createElement('style');
      style.id = 'sw2-styles';
      style.textContent = CSS;
      document.head.appendChild(style);
    }
  }

  function ensureAtBodyRoot() {
    function move() {
      ['isofin-sw2-bar', 'isofin-sw2-overlay', 'isofin-sw2-menu'].forEach(function (id) {
        var el = document.getElementById(id);
        if (el && el.parentNode !== document.body) document.body.appendChild(el);
      });
    }
    move();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', move);
    var tries = 0;
    var t = setInterval(function () { move(); if (++tries > 20) clearInterval(t); }, 300);
  }

  /* ═══════════════════════════════════════════════════════════════════════
     v229.7: RESUME-PROMPT — fragt User bei alter Berechnung (>24h)
     "Weiter mit Berechnung oder neu starten?" beim Klick auf Kalkulator-CTA
  ═══════════════════════════════════════════════════════════════════════ */
  var RESUME_ASKED_KEY = '__ISOWIZ_RESUME_ASKED__';
  var RESUME_THRESHOLD_MS = 24 * 60 * 60 * 1000;

  function _todayStr() {
    var d = new Date();
    return d.getFullYear() + '-' + ('0' + (d.getMonth()+1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
  }
  function _wasAskedToday() {
    try { return sessionStorage.getItem(RESUME_ASKED_KEY) === _todayStr(); } catch (_) { return false; }
  }
  function _markAskedToday() {
    try { sessionStorage.setItem(RESUME_ASKED_KEY, _todayStr()); } catch (_) {}
  }
  function _formatDateDE(ts) {
    if (!ts) return '';
    var d = new Date(ts);
    return ('0'+d.getDate()).slice(-2) + '.' + ('0'+(d.getMonth()+1)).slice(-2) + '.' + d.getFullYear();
  }
  function _analysisAgeMs() {
    try {
      var raw = localStorage.getItem(ISOWIZ_BORN_KEY) || '';
      var ts = parseInt(raw.split('::')[0], 10);
      if (!isFinite(ts)) return 0;
      return Date.now() - ts;
    } catch (_) { return 0; }
  }
  function _analysisBornTs() {
    try {
      var raw = localStorage.getItem(ISOWIZ_BORN_KEY) || '';
      var ts = parseInt(raw.split('::')[0], 10);
      return isFinite(ts) ? ts : 0;
    } catch (_) { return 0; }
  }

  var RESUME_CSS = '' +
    '#iso-resume-overlay{position:fixed;inset:0;background:rgba(0,0,0,.5);backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px);z-index:10500;display:none;align-items:center;justify-content:center;padding:16px;font-family:"Rubik",-apple-system,BlinkMacSystemFont,sans-serif;}' +
    '#iso-resume-overlay.is-open{display:flex;animation:isoRsmFade .25s ease-out;}' +
    '@keyframes isoRsmFade{from{opacity:0}to{opacity:1}}' +
    '#iso-resume-modal{background:#fff;border-radius:16px;max-width:440px;width:100%;padding:28px 24px 24px;box-shadow:0 25px 60px rgba(0,0,0,.3);position:relative;animation:isoRsmIn .3s cubic-bezier(.16,1,.3,1);}' +
    '@keyframes isoRsmIn{from{transform:translateY(20px) scale(.97);opacity:0}to{transform:translateY(0) scale(1);opacity:1}}' +
    '#iso-resume-modal .irm-close{position:absolute;top:12px;right:12px;width:32px;height:32px;border-radius:50%;background:#f5f5f5;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;font-size:20px;color:#666;line-height:1;}' +
    '#iso-resume-modal .irm-close:hover{background:#e5e5e5;color:#111;}' +
    '#iso-resume-modal h3{margin:0 0 6px;font-size:20px;font-weight:700;color:#1A1A1A;line-height:1.3;letter-spacing:-.01em;}' +
    '#iso-resume-modal .irm-sub{margin:0 0 18px;font-size:14px;color:#666;line-height:1.4;}' +
    '#iso-resume-modal .irm-card{background:#FAFAFA;border:1px solid #E5E5E5;border-radius:10px;padding:14px 16px;margin-bottom:18px;}' +
    '#iso-resume-modal .irm-card-row{display:flex;justify-content:space-between;gap:10px;font-size:14px;line-height:1.5;}' +
    '#iso-resume-modal .irm-card-row + .irm-card-row{margin-top:4px;}' +
    '#iso-resume-modal .irm-card-label{color:#666;}' +
    '#iso-resume-modal .irm-card-val{color:#1A1A1A;font-weight:600;text-align:right;}' +
    '#iso-resume-modal .irm-actions{display:flex;flex-direction:column;gap:10px;}' +
    '#iso-resume-modal .irm-btn{display:flex;align-items:center;justify-content:center;width:100%;padding:14px 18px;border-radius:10px;font-family:inherit;font-size:15px;font-weight:700;cursor:pointer;border:none;transition:transform .15s,filter .15s,background .15s;line-height:1.2;}' +
    '#iso-resume-modal .irm-btn:hover{transform:translateY(-1px);filter:brightness(1.06);}' +
    '#iso-resume-modal .irm-btn-primary{background:linear-gradient(180deg,#D6001C 0%,#A80016 100%);color:#fff;box-shadow:0 2px 8px rgba(214,0,28,.25);}' +
    '#iso-resume-modal .irm-btn-secondary{background:#fff;color:#1A1A1A;border:1.5px solid #E5E5E5;}' +
    '#iso-resume-modal .irm-btn-secondary:hover{border-color:#1A1A1A;}' +
    '#iso-resume-modal .irm-foot{margin-top:14px;font-size:12px;color:#999;text-align:center;line-height:1.4;}';

  function _ensureResumeCSS() {
    if (document.getElementById('iso-resume-styles')) return;
    var s = document.createElement('style');
    s.id = 'iso-resume-styles';
    s.textContent = RESUME_CSS;
    document.head.appendChild(s);
  }

  function _buildResumeModal(analysis, bornTs, onContinue, onRestart, onDismiss) {
    _ensureResumeCSS();
    var existing = document.getElementById('iso-resume-overlay');
    if (existing) existing.remove();

    var bottles = Number(analysis.calculatedBottles || analysis.bottles || 0);
    var label = analysis.barrierLabel || (analysis.moistureType === 'side' ? 'Flächensperre' : 'Horizontalsperre');
    var dim;
    if (analysis.moistureType === 'side') {
      var L = (Math.round(Number(analysis.surfaceLengthM)*10)/10).toString().replace('.', ',');
      var H = (Math.round(Number(analysis.surfaceHeightM)*10)/10).toString().replace('.', ',');
      var areaN = Number(analysis.surfaceLengthM) * Number(analysis.surfaceHeightM);
      var area = (Math.round(areaN*10)/10).toString().replace('.', ',');
      dim = L + '×' + H + 'm (' + area + 'm²)';
    } else {
      var W = (Math.round(Number(analysis.wallLengthM)*10)/10).toString().replace('.', ',');
      dim = W + 'm';
    }
    var dateStr = _formatDateDE(bornTs);
    var daysLeft = Math.max(0, Math.ceil((ISOWIZ_TTL_MS - (Date.now() - bornTs)) / (24 * 60 * 60 * 1000)));

    var overlay = document.createElement('div');
    overlay.id = 'iso-resume-overlay';
    overlay.innerHTML =
      '<div id="iso-resume-modal" role="dialog" aria-modal="true" aria-labelledby="irm-title">' +
        '<button class="irm-close" data-irm="dismiss" aria-label="Schließen">×</button>' +
        '<h3 id="irm-title">Letzte Berechnung gefunden</h3>' +
        '<p class="irm-sub">Vom ' + dateStr + ' — möchten Sie weitermachen?</p>' +
        '<div class="irm-card">' +
          '<div class="irm-card-row"><span class="irm-card-label">Sperrentyp</span><span class="irm-card-val">' + label + '</span></div>' +
          '<div class="irm-card-row"><span class="irm-card-label">Maße</span><span class="irm-card-val">' + dim + '</span></div>' +
          '<div class="irm-card-row"><span class="irm-card-label">Flaschen</span><span class="irm-card-val">' + bottles + ' × 500 ml</span></div>' +
        '</div>' +
        '<div class="irm-actions">' +
          '<button class="irm-btn irm-btn-primary" data-irm="continue">Weiter mit Berechnung →</button>' +
          '<button class="irm-btn irm-btn-secondary" data-irm="restart">Neu berechnen</button>' +
        '</div>' +
        '<div class="irm-foot">Berechnung läuft in ' + daysLeft + ' Tag' + (daysLeft === 1 ? '' : 'en') + ' ab</div>' +
      '</div>';
    document.body.appendChild(overlay);

    function close() {
      overlay.classList.remove('is-open');
      setTimeout(function () { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); }, 250);
    }

    overlay.addEventListener('click', function (e) {
      var act = e.target && e.target.getAttribute && e.target.getAttribute('data-irm');
      if (!act) {
        if (e.target === overlay) { close(); onDismiss && onDismiss(); }
        return;
      }
      close();
      if (act === 'continue') onContinue && onContinue();
      else if (act === 'restart') onRestart && onRestart();
      else if (act === 'dismiss') onDismiss && onDismiss();
    });

    document.addEventListener('keydown', function escHandler(e) {
      if (e.key === 'Escape') {
        document.removeEventListener('keydown', escHandler);
        close();
        onDismiss && onDismiss();
      }
    });

    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
  }

  /* v229.7: Full-Reset — Mirror der mini-cart.js "Sanierung neu berechnen"-Logik.
     Löscht ALLE Wizard-Keys (hardcoded + Wildcard __ISOWIZ*), ruft IsoWiz.Storage.resetAll(),
     leert Shopify-Cart via /cart/clear.js, dann navigiert. */
  function _performFullReset(targetUrl) {
    var hardKeys = [
      'isodash_project_v8','isofinHeroState','isofinAnalysis',
      '__ISOWIZ_RESUME_ANALYSIS__','__ISOWIZ_analysis','fa_state_v2',
      'isodash_moisture_check_completed','isodash_flow_phase','isodash_entry_mode',
      'isodash_capillary_fit','isodash_capillary_confidence','isodash_capillary_check',
      'isodash_masonry_type','isodash_moisture_type','isodash_analysis_source',
      'isodash_nav_unlock_shown','isodash_a2c_done','isodash_transition_shown',
      '__ISOWIZ_state__','__ISOWIZ_share_state__',
      'isodash-wiz:analysis','isodash-wiz:calcState','isofinCalcState'
    ];
    hardKeys.forEach(function (k) {
      try { localStorage.removeItem(k); } catch (_) {}
      try { sessionStorage.removeItem(k); } catch (_) {}
    });
    // Wildcard: alle __ISOWIZ* prefixed Keys
    try {
      for (var i = localStorage.length - 1; i >= 0; i--) {
        var lk = localStorage.key(i);
        if (lk && lk.indexOf('__ISOWIZ') === 0) localStorage.removeItem(lk);
      }
    } catch (_) {}
    try {
      for (var j = sessionStorage.length - 1; j >= 0; j--) {
        var sk = sessionStorage.key(j);
        if (sk && sk.indexOf('__ISOWIZ') === 0) sessionStorage.removeItem(sk);
      }
    } catch (_) {}
    // IsoWiz Storage API
    try {
      if (window.IsoWiz && window.IsoWiz.Storage && typeof window.IsoWiz.Storage.resetAll === 'function') {
        window.IsoWiz.Storage.resetAll();
      }
    } catch (_) {}
    // Shopify-Cart leeren + danach navigieren
    var done = false;
    function _go() {
      if (done) return;
      done = true;
      try { window.location.assign(targetUrl || '/pages/kalkulator'); }
      catch (_) { window.location.reload(); }
    }
    try {
      fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' }).then(_go, _go);
      setTimeout(_go, 1500);
    } catch (_) { _go(); }
  }

  function _interceptKalkulatorLinks() {
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('a[href*="/pages/kalkulator"]');
      if (!a) return;
      // Skip wenn modifier-keys (User will Tab-Öffnen erlauben)
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;
      if (_wasAskedToday()) return;
      var age = _analysisAgeMs();
      if (age < RESUME_THRESHOLD_MS) return;
      var analysis = readStoredAnalysisNormalized();
      if (!analysis) return;
      var bornTs = _analysisBornTs();
      if (!bornTs) return;

      e.preventDefault();
      e.stopPropagation();
      var targetUrl = a.href;

      _buildResumeModal(analysis, bornTs,
        function () { /* continue */
          _markAskedToday();
          window.location.assign(targetUrl);
        },
        function () { /* restart — Full-Reset wie mini-cart Reset-Button */
          _performFullReset(targetUrl);
        },
        function () { /* dismiss (X / Esc / Overlay-Klick) */
          _markAskedToday();
        }
      );
    }, true);
  }

  /* ═══════════════════════════════════════════════════════════════════════
     BOOT
  ═══════════════════════════════════════════════════════════════════════ */
  function boot() {
    ensureMount();
    ensureAtBodyRoot();
    attachEvents();
    consumePendingHeroScroll();
    refreshStickyVisibility();
    renderFromCart();
    _interceptKalkulatorLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
